import React from "react";
import HeroSection from "../../Components/Home/HeroSection";
import Services from "../../Components/Home/Services";
import InteriorDesign from "../../Components/Home/InteriorDesign";
import AllCategories from "../../Components/Home/AllCategories";
import ProductDisplay from "../../Components/Home/ProductDisplay";
import Banners from "../../Components/Home/Banners";
import Testimonials from "../../Components/Home/Testinomials";
import Partners from "../../Components/Home/Partners";
import HotDeals from "../../Components/Home/HotDeals";
import Navigationbar from "../../Components/Home/Navigationbar";
import DisplayHouse from "../../Components/DisplayHouse/DisplayHouse";
import ReturnAndExchangePolicy from "../../Components/Home/ReturnAndExchangePolicy";

const Home = () => {
  return (
    <React.Fragment>
      <HeroSection />
      <Services />
      <Navigationbar />
      <AllCategories />
      <InteriorDesign />
      <Partners />
      <ProductDisplay />
      <DisplayHouse />
      <Banners />
      <HotDeals />
      <Testimonials />
      <ReturnAndExchangePolicy />
    </React.Fragment>
  );
};

export default Home;
